<script>
/**
 * ****************************************************************************
 * @description     :   List Component
 * @created at      :   2025/12/04
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import { mapMutations } from 'vuex';

/**
 * Define content of list component
 */
var cusOnboardingTutorial = {
    template: template,
    props: {},
    data() {
        return {
            steps: [
                {
                    refKey: 'itemSort_tutorial',
                    msg: 'こちらの🔒マークを外した状態でメニュー項目をドラッグすると、順番を変更できます。'
                },
                {
                    refKey: 'user_tutorial',
                    msg: '個人設定やヘルプセンターへの移動。パスワード変更、ログアウトがこちらから行えます'
                },
                { refKey: 'CUS_System001_tutorial', msg: 'TOP画面に移動できます。' },
                { refKey: 'CUS_Order011_tutorial', msg: '新規の申込・見積を作成できます。' },
                {
                    refKey: 'CUS_Order021_tutorial',
                    msg: '申込状況を検索・確認できます。'
                },
                {
                    refKey: 'CUS_Delivery001_tutorial',
                    msg: '納品書を確認・ダウンロードできます。'
                },
                {
                    refKey: 'CUS_Billing001_tutorial',
                    msg: '請求書を確認・ダウンロードできます。'
                },
                {
                    refKey: 'CUS_FileDownload001_tutorial',
                    msg: 'ファイルダウンロードを確認・ダウンロードできます。'
                },
                {
                    refKey: 'CUS_Client003_tutorial',
                    msg: '発送拠点を管理できます。'
                },
                {
                    refKey: 'CUS_System003_tutorial',
                    msg: '担当者の変更・招待を行えます'
                },
                {
                    refKey: 'CUS_System002_tutorial',
                    msg: '個人設定ができます。'
                },
                {
                    refKey: 'CUS_Master005_tutorial',
                    msg: '現場担当者マスタができます。'
                },
                {
                    refKey: 'CUS_Master001_tutorial',
                    msg: 'テンプレートマスタを管理できます。'
                },
                { refKey: 'CUS_Start005_tutorial', msg: 'お問い合わせ先はこちら' },
                {
                    refKey: 'CUS_FAQ_tutorial',
                    msg: '操作にお困りの場合、まずはこちらをご確認ください'
                }
            ],
            current: 0,
            overlayVisible: false,
            boxVisible: false,
            skipCheck: false,
            resizeHandler: null
        };
    },

    mounted() {
        this.resizeHandler = () => {
            if (this.overlayVisible && this.boxVisible) {
                this.showStep(this.current);
            }
        };
        window.addEventListener('resize', this.resizeHandler);

        setTimeout(() => {
            this.startTutorial();
        }, 500);
    },

    beforeUnmount() {
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    },
    computed: {
        currentStep() {
            return this.steps[this.current] || null;
        },
        currentMessage() {
            return this.currentStep ? this.currentStep.msg : '';
        },
        isLastStep() {
            return this.current === this.steps.length - 1;
        },
        isFirstStep() {
            return this.current === 0;
        }
    },
    methods: {
        ...mapMutations('app', ['setShowCusTutorial']),

        startTutorial() {
            if (localStorage.getItem('menu_tutorial_skip') === '1') return;

            this.overlayVisible = true;
            this.boxVisible = true;
            this.showStep(0);
        },

        showStep(idx) {
            if (idx < 0 || idx >= this.steps.length) return;

            this.current = idx;
            const step = this.steps[idx];
            const el = document.getElementById(step.refKey);

            if (!el) {
                if (idx + 1 < this.steps.length) {
                    this.showStep(idx + 1);
                } else {
                    this.closeTutorial();
                }
                return;
            }

            const rect = el.getBoundingClientRect();
            const pad = 6;

            // Spotlight
            const overlay = this.$refs.overlay;
            if (overlay) {
                overlay.style.setProperty('--spot-left', rect.left - pad + 'px');
                overlay.style.setProperty('--spot-top', rect.top - pad + 'px');
                overlay.style.setProperty('--spot-width', rect.width + pad * 2 + 'px');
                overlay.style.setProperty('--spot-height', rect.height + pad * 2 + 'px');
            }

            // Balloon position
            const box = this.$refs.tutorialBox;
            if (box) {
                const screenWidth = window.innerWidth;

                if (rect.right + 340 > screenWidth) {
                    box.classList.remove('arrow-left');
                    box.classList.add('arrow-right');
                    box.style.left = rect.left - 340 + 'px';
                } else {
                    box.classList.remove('arrow-right');
                    box.classList.add('arrow-left');
                    box.style.left = rect.right + 20 + 'px';
                }

                box.style.top = rect.top + 'px';

                // Reset animation
                box.style.animation = 'none';
                void box.offsetWidth;
                box.style.animation = 'balloonFadeIn 0.45s ease-out forwards';
            }
        },

        nextOrClose() {
            if (this.isLastStep) {
                this.closeTutorial();
            } else {
                this.showStep(this.current + 1);
            }
        },

        prevStep() {
            if (this.current > 0) {
                this.showStep(this.current - 1);
            }
        },

        closeTutorial() {
            if (this.skipCheck) {
                localStorage.setItem('menu_tutorial_skip', '1');
            }
            this.overlayVisible = false;
            this.boxVisible = false;
            this.setShowCusTutorial(false);
        }
    }
};
export default cusOnboardingTutorial;
</script>
<style scoped>
#cus-onboarding-tutorial {
    font-size: 16px;
}
/* ---------------------------
   Right Top User Icon
--------------------------- */
#userIcon {
    position: fixed;
    right: 20px;
    top: 10px;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: white;
    border: 2px solid #00457c;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
}

/* ---------------------------
   Sidebar UI
--------------------------- */
.sidebar {
    width: 260px;
    background: #fff;
    border-right: 1px solid #ccc;
    height: 100vh;
}

.sidebar-header {
    padding: 15px;
    font-size: 18px;
    border-bottom: 1px solid #efefef;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.menu-item {
    padding: 14px 20px;
    border-bottom: 1px solid #f1f1f1;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
}

/* ---------------------------
   Overlay & Spotlight
--------------------------- */
.tutorial-overlay {
    position: fixed;
    inset: 0;
    pointer-events: auto;
    z-index: 9000;
    opacity: 0;
    animation: fadeIn 0.4s ease-out forwards;
}

.tutorial-overlay::before {
    content: '';
    position: fixed;
    left: var(--spot-left, 0px);
    top: var(--spot-top, 0px);
    width: var(--spot-width, 0px);
    height: var(--spot-height, 0px);
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
    border-radius: 12px;
    opacity: 0;
    animation: fadeIn 0.45s ease-out forwards;
    pointer-events: auto;
}

/* ---------------------------
    吹き出しボックス
--------------------------- */
.tutorial-box {
    position: fixed;
    background: #fff;
    padding: 14px;
    width: 328px;
    border-radius: 10px;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.25);
    z-index: 10000;

    opacity: 1;
    transform: translateY(-8px);
    animation: balloonFadeIn 0.45s ease-out forwards;
    height: fit-content;
    border: none;
}

.tutorial-box.arrow-left::before {
    content: '';
    position: absolute;
    left: -12px;
    top: 20px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 12px solid #fff;
}

.tutorial-box.arrow-right::before {
    content: '';
    position: absolute;
    right: -12px;
    top: 20px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 12px solid #fff;
}

.tutorial-buttons {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}
.tutorial-btn {
    height: 27px;
    min-width: 43px;
    border: 1px solid gray;
    border-radius: 3px;
}

.checkbox-area {
    margin-top: 12px;
}

/* Animation */
@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes balloonFadeIn {
    0% {
        opacity: 0;
        transform: translateY(-10px);
    }
    100% {
        opacity: 1;
        transform: translateY(0px);
    }
}
</style>
